import { createContext } from 'react';
import { INITIAL_CONTEXT_DATA } from './ProgressNotifierContext.constants';
import { ProgressNotifierContextData } from './ProgressNotifierContext.types';

export const ProgressNotifierContext = createContext<ProgressNotifierContextData>({
  ...INITIAL_CONTEXT_DATA,
});
